import { ExternallyReferenced } from '/src/models/externallyReferenced';
import { Auditable } from '@models/auditable';
import { loose, ndefault } from '@models/util';
import z from 'zod';

export type OrgType = z.infer<typeof OrgType>;
export type Org = z.infer<typeof Org>;

export const OrgType = z.enum(['global', 'tenant', 'group']);

export const Org = Auditable.extend({
  id: z.string(),
  type: loose(OrgType),
  name: ndefault(z.string(), ''),
  /** The tenant a group belongs to. Only set for groups. */
  parentOrgId: z.string().nullish(),
  accountReference: z.string().nullish(),
  ...ExternallyReferenced.shape,
});
